<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useActions } from '.'

const router = useRouter()
const props = defineProps<{
  pageNumber: number
  questionText: string
  inputValue: number | string
}>()
const actions = useActions(props, router)
</script>

<template>
  <div class="questions-template">
    <h1 class="questions-template-title">Q.{{ props.pageNumber }}</h1>
    <div class="questions-template-text">{{ props.questionText }}</div>
    <div class="questions-template-content">
      <slot />
    </div>
    <div class="questions-template-bottom">
      <div v-if="actions.canPrev()" class="questions-template-arrow questions-template-back" @click="actions.prev()">
        <img :src="'/assets/images/iconmonstr-arrow-64-icon-black.svg'" alt="" />
      </div>
      <div class="questions-template-page-number">{{ props.pageNumber }}/5</div>
      <div v-if="actions.canNext()" class="questions-template-arrow questions-template-next" @click="actions.next()">
        <img :src="'/assets/images/iconmonstr-arrow-64-icon-white.svg'" alt="" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.questions-template {
  position: relative;
  background-color: #eee;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  @media (max-width: 767px) {
    padding: 0 15px;
    justify-content: start;
  }
  &-title {
    margin-top: 80px;
    font-size: 32px;
    font-family: 'Roboto';
    margin-bottom: 0;
    @media (max-width: 767px) {
      margin-top: 40px;
      font-size: 24px;
    }
  }
  &-text {
    margin-top: 30px;
    font-size: 20px;
    font-weight: 600;
    @media (max-width: 767px) {
      font-size: 16px;
      text-align: left;
    }
  }
  &-content {
    width: 100%;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 120px;
    @media (max-width: 767px) {
      margin-top: 40px;
    }
  }
  &-bottom {
    position: absolute;
    bottom: 35px;
    width: 100%;
    max-width: 900px;
  }
  &-page-number {
    font-size: 16px;
  }
  &-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    box-shadow: 0px 2px 6px #0000001f;
    border-radius: 50%;
    cursor: pointer;
    img {
      width: 14px;
      height: 14px;
    }
  }
  &-back {
    left: 0;
    background-color: #fff;
    @media (max-width: 767px) {
      left: 15px;
    }
  }
  &-next {
    right: 0;
    background-color: #333;
    @media (max-width: 767px) {
      right: 15px;
    }
    transform: translateY(-50%) rotate(180deg);
  }
}
</style>
